import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {AddressBooksState} from './types';
import {actions} from './actions';
import {mutations} from './mutations';
import {getters} from './getters';

export const state: AddressBooksState = {
    addressBooks: [],
    addressBookContacts: [],
    addressBookItem: undefined,
};


export const addressbooks: Module<AddressBooksState, RootState> = {
    state,
    getters,
    actions,
    mutations
};
